<template>
  <div class="content">
    <header-top></header-top>
    <!-- 广告 -->
    <div class="banner" v-if="list.length">
      <div class="swiper"  v-if="list.length === 1" >
          <a :href="list[0].link" target="_blank"  v-if="list[0].link">
           <div :style='{ backgroundImage: "url(" + list[0].img + ")" }' style="background-position: center; background-size: cover;background-repeat: no-repeat;width: 100%;height: 100%;"></div>
          </a>
          <div v-else :style='{ backgroundImage: "url(" + list[0].img + ")" }' style="background-position: center; background-size: cover;background-repeat: no-repeat;width: 100%;height: 100%;"></div>
      </div>
      <swiper :options="swiperOption" class="swiper" v-if="list.length > 1 ">
        <swiper-slide v-for="(item,index) in list" :key="index">
          <a :href="item.link" target="_blank" v-if="item.link">
            <div :style='{ backgroundImage: "url(" + item.img + ")" }' style="background-position: center; background-size: cover;background-repeat: no-repeat;width: 100%;height: 100%;"></div>
          </a>
          <div v-else :style='{ backgroundImage: "url(" + item.img + ")" }' style="background-position: center; background-size: cover;background-repeat: no-repeat;width: 100%;height: 100%;"></div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="box">
      <div class="searchBox">
        <div class="search" v-if="cityData.length">
          <div class="choose">请选择：</div>
          <city-picker ref="cityPicker" :cityData="cityData" :default-city="defaultCity" :level="3" @change="changeSelect"></city-picker>
        </div>
      </div>
      <div class="company">
        <swiper v-if="showMaps" :options="companySwiperOption" class="swiper">
          <swiper-slide>
            <div class="total" @click="changeCompany(0)">
              <div class="message">总网点数</div>
              <div class="num">
                <img src="../../assets/img/005.png" alt class="image" />
                <div>{{urgentList.length}}&nbsp;个</div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide v-for="(citem, cindex) in companyList" :key="cindex">
            <div @click="changeCompany(citem.id)" class="total" :style="{backgroundColor: citem.bgColor}" :class="{active: companySelect && companySelect == citem.id}">
              <div class="message">{{companyCity ? '(' + citem.city + ')' + citem.title : citem.title}}</div>
              <div class="num">
                <img :src="citem.icon"  class="image" />
                <div>{{citem.urgentlists.length}}&nbsp;个</div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev" v-show="companyList.length >= 5"></div>
          <div class="swiper-button-next" slot="button-next" v-show="companyList.length >= 5"></div>
        </swiper>
      </div>
      <!-- 地图 -->
      <div class="map">
        <div class="companyInfo">
          <input type="text" placeholder="输入销售点名称进行搜索" v-model="searchCompany">
          <i class="iconfont icon-iconfonticonfontsousuo1"></i>
          <div class="info">
            <div class="everyCompany" v-for="(value, i) in urgentList" :key="i" @click="showDetail(value)" v-if="(companySelect === 0 || companySelect === value.companyId) && (!searchCompany || value.title.match(searchCompany))">
              <p>{{value.title}}</p>
              <span>{{value.addr}}</span>
            </div>
          </div>
        </div>
        <div class="searchCompany">
          <input type="text" placeholder="输入销售点名称进行搜索" v-model="searchText" @input="ChooseCompany" @focus="changeFlag" />
          <div class="searchResult" v-if="this.flag && this.searchText">
            <div v-for="(value, i) in searchList" :key="i" @click="showDetail(value)">{{value.title}}</div>
          </div>
        </div>
        <el-amap v-if="showMaps" ref="amapInfo" vid="amapInfo" :center="center" :amap-manager="amapManager" :zoom="zoom" :events="events" multiple class="amap-demo">
          <el-amap-marker
            v-if="( companySelect === 0 || companySelect === item.companyId ) && zoom >= changeZoom && (!searchCompany || item.title.match(searchCompany)) && (!searchText || item.title.match(searchText) )"
            vid="marker"
            :position="[item.lng, item.lat]"
            v-for="(item, index) in urgentList"
            :key="'urgent' + index"
            :zooms="zoom"
            :events="event"
            :extData="item"
            :content="item.selectContent || ''"
          ></el-amap-marker>
          <el-amap-text
            v-for="(item, index) in urgentList"
            v-if="(companySelect === 0 || companySelect === item.companyId) && item.showText && zoom >= changeZoom && (!searchCompany || item.title.match(searchCompany))"
            :text="item.text"
            :offset="item.offset"
            :position="[item.lng, item.lat]"
            :key="'urgentList' + index"
          ></el-amap-text>
          <el-amap-marker
            v-if="zoom < changeZoom && zoom > cityZoom"
            v-for="(marker, areaIndex) in areaMarkers"
            :key="areaIndex"
            :position="marker.position"
            :content="marker.content"
          ></el-amap-marker>
          <el-amap-marker v-if="zoom <= cityZoom && zoom > provinceZoom" v-for="(cityMarker, cityIndex) in cityMarkers"
            :key="cityIndex"
            :position="cityMarker.position"
            :content="cityMarker.content">
          </el-amap-marker>

          <el-amap-marker v-if="zoom <= provinceZoom && zoom >countryZoom" v-for="(provinceMarker, provinceIndex) in provinceMarkers"
            :key="provinceIndex"
            :position="provinceMarker.position"
            :content="provinceMarker.content">
          </el-amap-marker>

          <el-amap-marker v-if="zoom <= countryZoom "
            :position="country.position"
            :content="country.content">
          </el-amap-marker>
        </el-amap>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { index, getCityData } from "@/api/common.js";
import cityPicker from "@/components/CityPicker";
import { AMapManager, lazyAMapApiLoaderInstance } from "vue-amap";
import headerTop from "@/components/header";
import foot from "@/components/footer.vue";

export default {
  components: {
    cityPicker,
    headerTop,
    foot
  },
  watch: {
    searchCompany(val) {
      this.getAreaMarkers();
    },
    searchText(val) {
      this.searchCompany = val;
    }
  },
  filters: {},
  name: "maps",
  data() {
    let that = this;
    lazyAMapApiLoaderInstance.load().then(() => {
      that.amapManager = new AMapManager();
      setTimeout(() => {
        that.showMaps = true;
      }, 2000);
    });
    return {
      companySelect: 0,
      searchCompany: '',
      searchText: '',
      amapManager: null,
      showMaps: false,
      zoom: 12,
      changeZoom: 14,
      cityZoom: 10,
      provinceZoom: 8,
      countryZoom: 5,
      center: [118.063907, 24.560673],
      events: {
        //获取当前缩放zoom值
        zoomend: e => {
          this.zoom = this.$refs.amapInfo.$$getInstance().getZoom();
        },
        init(o) {
        }
      },
      event: {
        click(a) {
          let key;
          for(let item in a.target) {
            if(a.target[item].extData) {
              key = item;
              break;
            }
          }
          if(key) {
            let preShow = a.target[key].extData.showText;
            that.hideAllText();
            a.target[key].extData.showText = !preShow;
            that.clearAllContent();
            a.target[key].extData.selected = true;
            a.target[key].extData.selectContent = `<div style='width: 35px;height: 51px;background: url("http://iems.wingrain.com.cn/mark2.png") no-repeat center;background-size: contain;'></div>`;
          }
        }
      },
      areaMarkers: [],
      cityMarkers: [],
      provinceMarkers: [],
      country: {
        position: [103.278541, 33.41711],
        content: '',
        count: 0
      },
      //   省市区初始值
      defaultCity: {
        province: "福建省",
        city: "厦门市",
        area: ""
      },
      //广告
      list: [],
      //   企业分类数据
      companyList: [],
      swiperOption: {
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      companySwiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      //总网点数
      total: "",
      label: {
        content: "",
        offset: [0, 20]
      },
      urgentList: [],
      searchList: [],
      loading: false,
      flag: false,
      cityData: [],
      //没有选择城市时，需在分类前加上城市
      companyCity: false,
      allCity: [],
      allArea: [],
      allProvince: []
    };
  },
  mounted() {
    if(window.outerWidth < 980) {
      this.companySwiperOption.slidesPerView = 3;
      this.companySwiperOption.spaceBetween = 10;
    }
    this.getBannerList();
    this.clearAllContent();
    this.handleCityData()
  },
  methods: {
    // remoteMethod(query){
    //   // this.searchText = query
    //   console.log(this.searchText)
    //   if (query !== '') {
    //       this.loading = true;
    //       setTimeout(() => {
    //         this.loading = false;
    //         this.searchList = this.urgentList.filter(item => {
    //           return item.title.toLowerCase()
    //             .indexOf(query.toLowerCase()) > -1;
    //         });
    //       }, 200);
    //     } else {
    //       this.searchList = [];
    //     }
    // },
    changeCompany(id) {
      this.companySelect = id;
      this.getAreaMarkers();
      this.hideAllText();
    },
    dateFormat(date, fmt = "YYYY-mm-dd HH:MM:SS") {
      date = new Date(date);
      let ret;
      let opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")));
        }
      }
      return fmt;
    },
    hideAllText(item) {
      for(let i = 0; i < this.urgentList.length; i++) {
        this.urgentList[i].showText = false;
      }
    },
    showDetail(item) {
      this.zoom = this.changeZoom;
      this.center = [item.lng, item.lat];
      this.hideAllText();
      this.clearAllContent();
      item.selected = true;
      item.selectContent = `<div style='width: 35px;height: 51px;background: url("http://iems.wingrain.com.cn/mark2.png") no-repeat center;background-size: contain;'></div>`;
      // this.searchText = item.title;
      this.flag = false;
    },
    clearAllContent() {
      for(let i = 0; i < this.urgentList.length; i++) {
        this.urgentList[i].selected = false;
        this.urgentList[i].selectContent = `<div style='width: 35px;height: 51px;background: url("http://iems.wingrain.com.cn/mark1.png") no-repeat center;background-size: contain;'></div>`;
      }
    },
    ChooseCompany() {
      this.searchList = this.urgentList.filter(item => {
        return item.title.toLowerCase()
          .indexOf(this.searchText.toLowerCase()) > -1;
      });
    },
    changeFlag() {
      this.flag = true;
    },
    hideFLag() {
      this.flag = false;
    },
    getBannerList() {
      index("urgentadMaps", { position: 1 }).then(res => {
        this.list = res.data.rows;
      });
    },
    //改变所选省市区事件
    changeSelect(e) {
      this.searchCompany = '';
      this.searchText = '';
      this.companySelect = 0;
      this.urgentList = [];
      index('urgentCityList', {
        province: e.data[0],
        city: e.data[1] === '全部' ? '' : e.data[1] ,
        area: e.data[2] === '全部' ? '' : e.data[2]
      }).then(res => {
        this.companyList = res.data.company.rows;
        this.allProvince = [res.data.province];
        if(!res.data.city && !res.data.area) {
          this.allCity = res.data.allCity.rows || [];
          this.allArea = res.data.allArea.rows || [];
        } else if(res.data.city && !res.data.area) {
          this.allCity = [res.data.city];
          this.allArea = res.data.allArea.rows;
        } else {
          this.allCity = [res.data.city];
          this.allArea = [res.data.area];
        }
        if(res.data.province && !res.data.city) {
          this.companyCity = true;
          this.center = [res.data.province.lng, res.data.province.lat];
          this.zoom = this.provinceZoom;
        } else if(res.data.province && res.data.city && !res.data.area) {
          this.companyCity = false;
          this.center = [res.data.city.lng, res.data.city.lat];
          this.zoom = this.cityZoom;
        } else {
          this.center = [res.data.area.lng, res.data.area.lat];
          this.zoom = this.changeZoom;
        }
        this.getStationInfoList(res.data.list.rows);
      });
    },
    getAreaMarkers() {
      let arr = [];
      for (let i = 0; i < this.allArea.length; i++) {
        arr.push({
          name: this.allArea[i].name,
          position: [this.allArea[i].lng, this.allArea[i].lat],
          content: '',
          count: 0
        })
      }
      for (let i = 0; i < this.urgentList.length; i++) {
        for (let m = 0; m < arr.length; m++) {
          if (arr[m].name === this.urgentList[i].area && (this.companySelect === 0 || this.companySelect === this.urgentList[i].companyId)) {
            if(!this.searchCompany || this.urgentList[i].title.match(this.searchCompany)) {
              arr[m].count++;
            }
            break;
          }
        }
      }
      for (let m = 0; m < arr.length; m++) {
        arr[m].content = `<div class="marker-area-title"><p>${arr[m].name}</p><p>${arr[m].count}</p></div>`;
      }
      this.areaMarkers = [];
      arr.filter(item => {
        if (item.count !== 0) {
          this.areaMarkers.push(item);
        }
      });
      let cityArr = [];
      for (let i = 0; i < this.allCity.length; i++) {
        cityArr.push({
          name: this.allCity[i].name,
          position: [this.allCity[i].lng, this.allCity[i].lat],
          count: 0
        })
      }
      for(let i = 0;i < this.urgentList.length; i++){
        for (let m = 0; m < cityArr.length; m++) {
          if (cityArr[m].name === this.urgentList[i].city && (this.companySelect === 0 || this.companySelect === this.urgentList[i].companyId)) {
            if(!this.searchCompany || this.urgentList[i].title.match(this.searchCompany)) {
              cityArr[m].count++;
            }
            break;
          }
        }
      }
      for (let m = 0; m < cityArr.length; m++) {
        cityArr[m].content = `<div class="marker-area-title"><p>${cityArr[m].name}</p><p>${cityArr[m].count}</p></div>`;
      }
      this.cityMarkers = [];
      cityArr.filter(item => {
        if (item.count !== 0) {
          this.cityMarkers.push(item);
        }
      });
      let provinceArr = [];
      for (let i = 0; i < this.allProvince.length; i++) {
        provinceArr.push({
          name: this.allProvince[i].name,
          position: [this.allProvince[i].lng, this.allProvince[i].lat],
          count: 0
        })
      }
      for(let i = 0;i < this.urgentList.length; i++){
        for (let m = 0; m < provinceArr.length; m++) {
          if (provinceArr[m].name === this.urgentList[i].province && (this.companySelect === 0 || this.companySelect === this.urgentList[i].companyId)) {
            if(!this.searchCompany || this.urgentList[i].title.match(this.searchCompany)) {
              provinceArr[m].count++;
            }
            break;
          }
        }
      }
      for (let m = 0; m < provinceArr.length; m++) {
        provinceArr[m].content = `<div class="marker-area-title"><p>${provinceArr[m].name}</p><p>${provinceArr[m].count}</p></div>`;
      }
      this.provinceMarkers = [];
      provinceArr.filter(item => {
        if (item.count !== 0) {
          this.provinceMarkers.push(item);
        }
      });
      this.country.content = `<div class="marker-area-title"><p>中国</p><p>${this.urgentList.length}</p></div>`;
    },
    handleCityData() {
      getCityData().then(res => {
        this.cityData = res;
      });
    },
    getStationInfoList(res) {
      for (let i = 0; i < res.length; i++) {
        let addr = res[i].addr ? `<p>地址:${res[i].province + res[i].city + res[i].area + res[i].addr}</p>` : '';
        let endTime = res[i].endTime ? `<p>有效期:${this.dateFormat(res[i].endTime)}</p>` : '';
        let contact = res[i].contact ? `<p>联系人:${res[i].contact}</p>` : '';
        let mobile = res[i].mobile ? `<p>联系电话:${res[i].mobile}</p>` : '';
        let startTime = res[i].startTime ? `<p>认证时间:${this.dateFormat(res[i].startTime)}</p>` : '';
        let storeImgs = '';
        for(let m = 0; m < res[i].storeImgs.length; m++) {
          storeImgs += `<a href="${res[i].storeImgs[m]}" target="_blank" ontouchstart="window.open('${res[i].storeImgs[m]}')"><img width="50" height="50" src="${res[i].storeImgs[m]}" /></a>`;
        }
        if(storeImgs.length) {
          storeImgs = `<div>门头照片：<div>${storeImgs}</div></div>`;
        }
        let insideImgs = '';
        for(let m = 0; m < res[i].insideImgs.length; m++) {
          insideImgs += `<a href="${res[i].insideImgs[m]}" target="_blank" ontouchstart="window.open('${res[i].insideImgs[m]}')"><img width="50" height="50" src="${res[i].insideImgs[m]}" /></a>`;
        }
        if(insideImgs.length) {
          insideImgs = `<div>店内照片：<div>${insideImgs}</div></div>`;
        }
        let others = '';
        for(let m = 0; m < res[i].others.length; m++) {
          others += `<a href="${res[i].others[m]}" target="_blank" ontouchstart="window.open('${res[i].others[m]}')"><img width="50" height="50" src="${res[i].others[m]}" /></a>`;
        }
        if(others.length) {
          others = `<div>其他：<div>${others}</div></div>`;
        }
        let record = res[i].record ? `<div>核查记录：${res[i].record}</div>` : '';
        res[i].text = `<div style="width: 250px;word-break: break-all;white-space: initial;"><p>名称:${res[i].title}</p>
        ${addr}
        ${startTime}
        ${endTime}
        ${contact}
        ${mobile}
        ${storeImgs}
        ${insideImgs}
        ${others}
        ${record}
        </div>`;
        res[i].offset = [160, 0];
        res[i].showText = false;
        // selectContent = `<div style='width: 19px;height: 33px;background: url("http://iems.wingrain.com.cn/mark1.png") no-repeat center;background-size: contain;'></div>`;
        res[i].selectContent = `<div style='width: 35px;height: 51px;background: url("http://iems.wingrain.com.cn/mark1.png") no-repeat center;background-size: contain;'></div>`;
      }
      this.urgentList = res;
      this.getAreaMarkers();
      this.searchList = this.urgentList;
    }
  }
};
</script>

<style lang="scss" scoped>
html,
#app,
.content {
  height: 100%;
  min-height: 920px;
  min-width: 1080px;
  width: 100%;
}
.box {
  margin: 40px 20px 20px;
}
.banner {
  position: relative;
  width: 100%;
  height: 23%;
}
.swiper {
  height: 100%;
}
.swiper-pagination {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.searchBox {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: space-between;
}
.search {
  flex: 2;
  .choose {
    float: left;
    line-height: 34px;
  }
}
.city-picker {
  z-index: 99;
}
.company {
  margin-top: 30px;
  height: 180px;
  .swiper {
    height: 100%;
  }
}
.total {
  width: 100%;
  height: 100%;
  background-color: #a5d9ff;
  border-radius: 10px;
  cursor: pointer;
  &.active {
    background-color: rgb(255, 255, 255) !important;
    box-shadow: 0 0 0 1px #ccc inset;
  }
}
.message {
  padding: 3px 0 0 13px;
  color: #3a7dad;
  font-size: 14px;
  // line-height: 45px;
  height: 45px;
  border-bottom: 1px solid rgb(187, 181, 181);
}
.num {
  display: flex;
  justify-content: center;
  font-size: 20px;
  text-align: center;
  padding-top: 40px;
  div {
    line-height: 34px;
    color: #0464a6;
  }
}
.image {
  width: 32px;
  height: 35px;
  margin-right: 10px;
}
.map {
  width: 100%;
  min-width: 1080px;
  height: 700px;
  margin-top: 20px;
  overflow: hidden;
  .amap-demo {
    float: left;
    width: calc(100% - 222px);
    height: 100%;
  }
}
.companyInfo {
  position: relative;
  float: right;
  width: 202px;
  input {
    padding-left: 10px;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 5px;
    outline: none;
  }
  input::-webkit-input-placeholder {
    color: #bcbcbc;
    font-size: 14px;
  }
  .iconfont {
    position: absolute;
    top: 9px;
    right: 15px;
    color: #bcbcbc;
    font-size: 20px;
  }
}
.info {
  width: 100%;
  height: 640px;
  margin-top: 20px;
  overflow-y: scroll;
  .everyCompany {
    width: 90%;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 14px;
    padding: 10px 5px;
    cursor: pointer;
    p {
      color: #444;
      margin: 0 0 3px;
      padding: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span {
      color: #bcbcbc;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
    }
  }
}
.searchCompany {
  display: none;
}

@media screen and (min-width: 320px) and (max-width: 980px) {
  /*.swiper-slide {*/
  /*  margin-right: 0!important;*/
  /*  margin: 0 15px;*/
  /*}*/

  .swiper {
    padding: 0 10px;
  }

  .map {
    /*display: none;*/
    width: 100%;
    min-width: 100%;
    height: 500px;
  }
  .companyInfo {
    display: none;
  }
  .info {
    height: 440px;
      .everyCompany {
        font-size: 12px;
      }
  }
  .map .amap-demo {
    /*width: 100%;*/
    /*float: right;*/
    width: calc(100%);
  }
  .banner {
    /*display: none;*/
    margin-top: 0;
  }

  .content {
    width: 100%;
    min-width: 100%;
  }

  .box {
    margin: 0;
  }
  .search {
    padding: 10px 15px 0;
  }
  .searchBox {
    display: initial;
  }
  .btns {
    margin: 10px 0;
  }
  .company {
    height: initial;
  }
  .message {
    border-bottom: none;
  }
  .image {
    width: 25px;
    height: 25px;
  }
  .num {
    padding-top: 0;
    padding-bottom: 10px;
    div{
      line-height: 25px;
    }
  }
  .swiper-button-prev, .swiper-button-next {
    width: 13px;
    height: 22px;
    background-size: cover;
    margin-top: -11px;
  }
  .swiper-slide {
    line-height: 1;
  }
  .loginBtn {
    margin-top: 10px;
    display: flex;
    justify-content:flex-end;
  }
  .searchCompany {
    display: block;
    margin: 10px 20px;
  }
  .el-select {
    width: 300px;
  }
  .searchCompany {
    position: relative;
    input {
      width: 100%;
      padding: 8px 5px ;
      outline: none;
      border: 1px solid #ccc;
      border-radius: 5px;
      box-sizing: border-box;
    }
    .searchResult {
      overflow-y:auto;
      position: absolute;
      background-color: #fff;
      top:35px;
      left: 5px;
      width: 300px;
      border: 1px solid #ccc;
      height: 120px;
      z-index: 2;
      div {
        padding:  5px 0 5px 20px;
        border-bottom: 1px solid #ccc;
      }
    }
  }
}
</style>

<style>
.marker-area-title {
  text-align: center;
  background-color: #5eacda;
  height: 85px;
  width: 85px;
  border-radius: 50%;
  color: #ffffff;
}
.marker-area-title p {
  margin: 0;
}
.marker-area-title p:first-child {
  padding-top: 20px;
  margin-bottom: 10px;
}
.map .amap-icon img, .map .amap-overlay-text-container img {
  max-width: 100% !important;
  height: auto;
}
</style>
